export default defineNuxtRouteMiddleware(async () => {
  await callOnce(() => useMainStore().getFeatureFlags())
})
